var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.show),expression:"error.show"}]},[_vm._v("\n    "+_vm._s(_vm.error.txt)+"\n  ")]),_vm._v(" "),_c('ul',{staticClass:"feature__pills list-unstyled m-0 p-0"},_vm._l((_vm.state),function(tag){
var _obj;
return _c('li',{key:tag.name,class:( _obj = {'feature__pills-pill': true}, _obj[tag.state] = true, _obj['disabled'] =  _vm.$props.disabled, _obj ),attrs:{"title":tag.label},on:{"click":function($event){return _vm.click(tag.name)}}},[_vm._v("\n      "+_vm._s(tag.label)+"\n    ")])}),0)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dcfb134c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/property-qc/TagPills.vue
// module id = 826
// module chunks = 0